var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanKit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H34V28C34 31.3137 31.3137 34 28 34H6C2.68629 34 0 31.3137 0 28V6Z",
    fill: "#FFA270"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99966 17.5003V18.2783C9.11534 18.7429 8.6001 19.3005 8.6001 19.9001C8.6001 21.5202 12.3609 22.8335 17.0001 22.8335C21.6393 22.8335 25.4001 21.5202 25.4001 19.9001C25.4001 19.3003 24.8845 18.7425 23.9997 18.2779V17.5C26.148 18.3393 27.5 19.559 27.5 20.9166C27.5 23.448 22.799 25.5001 17 25.5001C11.201 25.5001 6.5 23.448 6.5 20.9166C6.5 19.5592 7.85173 18.3395 9.99966 17.5003Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1522 8C14.5305 8 13.9785 8.39784 13.7819 8.98767L13.3889 10.1667H11.9444C11.1467 10.1667 10.5 10.8134 10.5 11.6111V18.1111C10.5 18.9089 11.1467 19.5556 11.9444 19.5556H22.0556C22.8533 19.5556 23.5 18.9089 23.5 18.1111V11.6111C23.5 10.8134 22.8533 10.1667 22.0556 10.1667H20.6111L20.2181 8.98767C20.0215 8.39784 19.4695 8 18.8478 8H15.1522ZM19.5278 14.8611C19.5278 16.2572 18.3961 17.3889 17 17.3889C15.6039 17.3889 14.4722 16.2572 14.4722 14.8611C14.4722 13.4651 15.6039 12.3333 17 12.3333C18.3961 12.3333 19.5278 13.4651 19.5278 14.8611ZM21.3333 13.0556C21.7322 13.0556 22.0556 12.7322 22.0556 12.3333C22.0556 11.9345 21.7322 11.6111 21.3333 11.6111C20.9345 11.6111 20.6111 11.9345 20.6111 12.3333C20.6111 12.7322 20.9345 13.0556 21.3333 13.0556Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanKit);
export default __webpack_public_path__ + "static/media/ScanKit.7da11195289258a0da2784bc18fc6f31.svg";
export { ForwardRef as ReactComponent };